export default {"src":"/uk/_next/static/media/errorIcon.2b3005cf.svg","height":120,"width":120,"blurWidth":0,"blurHeight":0};